import {
  FiatPrice,
  Product,
  ProductOpaqueValue,
} from "@b2bportal/purchase-api";
import { State } from "xstate";
import { ParentState } from "../../../types";
import { DisruptionProtectionContextV1 } from "./context";
import {
  CartContext,
  FlightPassengerInformationContext,
} from "@checkout/index";
import { CommonParentContext } from "@checkout/states/common";
import { FlightContext } from "../Flight";

export interface DisruptionQuoteRequestV1 {
  quoteIds: Array<string>;
  tripId: string;
  fareId: string;
}

export interface DisruptionProtectionProductV1 extends ProductOpaqueValue {
  type: typeof Product.AirDisruption;
  value: DisruptionQuoteRequestV1;
}

export enum DisruptionProtectionStateV1 {
  route = "route",
  addProduct = "addProduct",
}

export enum DisruptionEventType {
  INIT_DISRUPTION_STATE = "INIT_DISRUPTION_STATE",
}

export interface InitDisruptionStateEvent {
  type: DisruptionEventType.INIT_DISRUPTION_STATE;
  state: DisruptionProtectionContextV1;
}

export type DisruptionEvents = InitDisruptionStateEvent;

export interface PartialParentContextWithAirDisruptionV1
  extends CartContext,
    CommonParentContext,
    FlightContext {
  [ParentState.passengerInformation]: FlightPassengerInformationContext;
  [ParentState.disruptionV1]: DisruptionProtectionContextV1;
}

export type DisruptionUpdateStateTypeV1 =
  State<PartialParentContextWithAirDisruptionV1>;

export type DisruptionUpdateStateWithoutValueV1 = Pick<
  DisruptionUpdateStateTypeV1,
  "context"
>;
